import {
  Button,
  Icon,
  Popover,
  Text,
  WithPopover,
} from '@lightspeed/design-system-react'
import { T } from '@transifex/react'
import React, { useEffect, useState } from 'react'
import {
  useSaleManager,
  useRegisterManager,
  useTrainingModeManager,
} from '../../../ng-compat/hooks'
import { useAppDispatch, useAppSelector } from '../../../state/hooks'
import {
  hideAttachCustomerTooltip,
  selectHideAttachCustomerTooltip,
} from '../../../state/slices/currentSale/currentSaleSlice'

export const AddCustomerPopover = () => {
  const dispatch = useAppDispatch()
  const saleManager = useSaleManager()
  const registerManager = useRegisterManager()
  const trainingModeManager = useTrainingModeManager()
  const hidecustomerTooltip = useAppSelector(selectHideAttachCustomerTooltip)

  const [showPopover, setShowPopover] = useState<boolean>(false)

  useEffect(() => {
    if (!hidecustomerTooltip) {
      dispatch(hideAttachCustomerTooltip(true))
      saleManager.saveSale()

      if (
        registerManager.isAddCustomerEnabled() &&
        !trainingModeManager.trainingModeEnabled
      ) {
        setTimeout(() => {
          setShowPopover(true)
        }, 350)
      }
    }
  }, [
    dispatch,
    hidecustomerTooltip,
    registerManager,
    saleManager,
    trainingModeManager.trainingModeEnabled,
  ])

  const closeTooltip = () => {
    setShowPopover(false)
  }

  return (
    <>
      {showPopover && (
        <WithPopover direction="left" className="vd-popover-container-default">
          <div></div>
          <Popover
            className="vd-popover--tooltip wr-tooltip"
            onClose={closeTooltip}
          >
            <Text type="label" tag="p" className="vd-mb3">
              <Icon icon="fa-info-circle" className="vd-mr2" />
              <T _str="Add a customer to this sale" _context="Tooltip header" />
            </Text>
            <Text tag="p">
              <T
                _str="You haven't added a customer to this sale yet. You can search for an existing customer, add a new one, or just continue to pay."
                _context="Tooltip message"
              />
            </Text>
            <div className="vd-dialog-actions">
              <Button
                className="vd-btn vd-btn--go vd-mt1"
                onClick={closeTooltip}
                data-track="dismiss-tooltip"
              >
                <T _str="Got it" _context="Dismiss tooltip button" />
              </Button>
            </div>
          </Popover>
        </WithPopover>
      )}
    </>
  )
}
